import { graphql } from 'gatsby';
import React, { useState } from 'react';
import Layout from '~/components/Layout';
// import HeroHeading from '~/components/organisms/HeroHeading';
// import ContactForm from '~/components/organisms/ContactForm';
import HeroContact from '~/components/organisms/HeroContact';
import TwoColumns from '~/components/organisms/TwoColumns';
import Ctas from '~/components/organisms/Ctas';
import FeaturedResources from '~/components/organisms/FeaturedResources';
import Seo from 'gatsby-plugin-wpgraphql-seo';
import CustomSEO from '~/components/seo/CustomSEO';
import usePostPreviewsByCategory from '~/hooks/usePostPreviewsByCategory';

export default function Contact({ data: { wpPage } }) {
  const page = wpPage.contact.contact;
  const hero = page.hero;
  const rl = wpPage?.resourcesListing?.resourcesListing;
  const selectedCategory = rl?.categories?.[0];

  const posts = usePostPreviewsByCategory({
    resourceType: 'residential',
    categorySlug: selectedCategory?.category?.slug,
  });

  const featuredCategory = {
    name: selectedCategory?.category?.name,
    posts: {
      nodes: posts || [],
    },
  };

  const featuredType =
    selectedCategory?.type === 'Three Column' ||
    selectedCategory?.type === 'Three Columns' ||
    selectedCategory?.type === '3-col'
      ? '3-col'
      : 'grid';

  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <>
      <Layout>
        <Seo post={wpPage} />
        <CustomSEO seo={wpPage?.seo} />

        {/* <div className='py-20 pt-32 md:py-36 md:pt-52' style={{ paddingBottom: 0 }}>
          <ContactForm isSubmitted={isSubmitted} setIsSubmitted={setIsSubmitted} />
        </div>
        <div style={{ marginTop: "-13rem" }}>
          <HeroHeading {...hero} className="!bg-transparent !mb-0 md:!mb-0" />
        </div> */}

        <HeroContact
          {...hero}
          isSubmitted={isSubmitted}
          setIsSubmitted={setIsSubmitted}
          className="!bg-transparent !mb-0 md:!mb-0"
        />

        <TwoColumns {...wpPage.contact.contact} />
        {/* <Ctas {...wpPage.contact.contact.ctas} /> */}

        {posts?.length > 0 && selectedCategory && (
          <FeaturedResources
            heading={selectedCategory?.header?.heading}
            button={selectedCategory?.header?.button}
            type={featuredType}
            category={featuredCategory}
          />
        )}

        <div style={{ backgroundColor: 'white', paddingBottom: '144px' }}>
          <div className="social-section">
            <div className="overlay" />

            <div className="content">
              <h2>Get social with us</h2>
              <p>
                Follow City Relay on our social channels to stay updated with the latest
                news, property tips, industry insights and company updates.
              </p>

              <div className="icons">
                <span className="icon">
                  <a href="https://x.com/city_relay" target="_blank" rel="noopener noreferrer">
                    <svg width="32" height="29" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_6650_56734)">
                        <path d="M25.2019 0.00146484H30.1087L19.3887 12.2843L32 28.9985H22.1254L14.3913 18.8614L5.54176 28.9985H0.631872L12.0981 15.8606L0 0.00146484H10.1252L17.1162 9.26716L25.2019 0.00146484ZM23.4797 26.0542H26.1987L8.64787 2.79111H5.73011L23.4797 26.0542Z" fill="white" />
                      </g>
                      <defs>
                        <clipPath id="clip0_6650_56734">
                          <rect width="32" height="29" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </span>

                <span className="icon">
                  <a href="https://www.facebook.com/CityRelayLondon/" target="_blank" rel="noopener noreferrer">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_6649_56712)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.390625 15.7544C0.390625 23.5434 6.04769 30.0205 13.4464 31.3338V20.0184H9.52967V15.667H13.4464V12.1849C13.4464 8.26823 15.9701 6.09313 19.5395 6.09313C20.6702 6.09313 21.8896 6.26678 23.0202 6.44041V10.4446H21.0187C19.1034 10.4446 18.6687 11.4016 18.6687 12.621V15.667H22.8465L22.1507 20.0184H18.6687V31.3338C26.0674 30.0205 31.7245 23.5448 31.7245 15.7544C31.7245 7.08929 24.6744 0 16.0576 0C7.44074 0 0.390625 7.08929 0.390625 15.7544Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6649_56712">
                          <rect width="32" height="32" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </span>

                <span className="icon">
                  <a href="https://www.instagram.com/city_relay/" target="_blank" rel="noopener noreferrer">
                    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.08984 0.0927963C10.7391 0.0168726 11.2649 0 15.4661 0C19.6672 0 20.1931 0.0182782 21.841 0.0927963C23.4887 0.167314 24.6135 0.430238 25.5978 0.811266C26.6284 1.20073 27.5633 1.80953 28.3366 2.59689C29.1241 3.3688 29.7314 4.30238 30.1195 5.3344C30.5019 6.31859 30.7634 7.4434 30.8394 9.08843C30.9153 10.7405 30.9322 11.2663 30.9322 15.4661C30.9322 19.6673 30.9138 20.1931 30.8394 21.8423C30.7648 23.4873 30.5019 24.6121 30.1195 25.5964C29.7314 26.6285 29.1231 27.5637 28.3366 28.3367C27.5633 29.124 26.6284 29.7314 25.5978 30.1195C24.6135 30.5019 23.4887 30.7634 21.8437 30.8393C20.1931 30.9153 19.6672 30.9321 15.4661 30.9321C11.2649 30.9321 10.7391 30.9139 9.08984 30.8393C7.4448 30.7649 6.32 30.5019 5.33579 30.1195C4.30368 29.7314 3.36854 29.123 2.59548 28.3367C1.80865 27.5643 1.19977 26.6296 0.811266 25.5977C0.430239 24.6135 0.168721 23.4887 0.0927963 21.8438C0.0168726 20.1917 0 19.6658 0 15.4661C0 11.2649 0.0182782 10.7391 0.0927963 9.09124C0.167316 7.4434 0.430239 6.31859 0.811266 5.3344C1.20035 4.30249 1.8097 3.36782 2.5969 2.59549C3.36885 1.80883 4.30304 1.19995 5.33439 0.811266C6.3186 0.430238 7.4434 0.168721 9.08843 0.0927963H9.08984ZM21.7158 2.87668C20.0848 2.80217 19.5956 2.7867 15.4661 2.7867C11.3366 2.7867 10.8474 2.80217 9.21637 2.87668C7.70773 2.94558 6.88943 3.19726 6.3439 3.40957C5.62262 3.69076 5.10662 4.024 4.56531 4.5653C4.05217 5.06451 3.65728 5.67223 3.40956 6.34391C3.19726 6.88944 2.94559 7.70772 2.87669 9.21638C2.80217 10.8473 2.78671 11.3366 2.78671 15.4661C2.78671 19.5955 2.80217 20.0848 2.87669 21.7158C2.94559 23.2245 3.19726 24.0427 3.40956 24.5883C3.65702 25.2589 4.05211 25.8678 4.56531 26.3668C5.06443 26.8801 5.67324 27.2752 6.3439 27.5225C6.88943 27.7349 7.70773 27.9865 9.21637 28.0555C10.8474 28.1299 11.3352 28.1454 15.4661 28.1454C19.5969 28.1454 20.0848 28.1299 21.7158 28.0555C23.2245 27.9865 24.0427 27.7349 24.5883 27.5225C25.3095 27.2414 25.8256 26.9081 26.3669 26.3668C26.88 25.8678 27.2752 25.2589 27.5226 24.5883C27.7349 24.0427 27.9866 23.2245 28.0555 21.7158C28.13 20.0848 28.1455 19.5955 28.1455 15.4661C28.1455 11.3366 28.13 10.8473 28.0555 9.21638C27.9866 7.70772 27.7349 6.88944 27.5226 6.34391C27.2413 5.62262 26.9082 5.10662 26.3669 4.5653C25.8676 4.05222 25.2599 3.65732 24.5883 3.40957C24.0427 3.19726 23.2245 2.94558 21.7158 2.87668ZM13.4907 20.2338C14.5938 20.6931 15.8224 20.755 16.9661 20.4092C18.11 20.0633 19.0983 19.331 19.7623 18.3374C20.4262 17.3438 20.7247 16.1506 20.6065 14.9614C20.4884 13.7723 19.9611 12.661 19.1147 11.8175C18.5751 11.2782 17.9227 10.8654 17.2044 10.6085C16.486 10.3517 15.7197 10.2573 14.9606 10.3322C14.2015 10.4071 13.4683 10.6493 12.814 11.0416C12.1597 11.4338 11.6006 11.9662 11.1768 12.6005C10.7529 13.2347 10.475 13.955 10.363 14.7096C10.251 15.4642 10.3076 16.2342 10.5289 16.9641C10.7502 17.6942 11.1306 18.3661 11.6427 18.9315C12.1548 19.4968 12.786 19.9416 13.4907 20.2338ZM9.84486 9.84486C10.5831 9.10667 11.4594 8.5211 12.4239 8.12161C13.3884 7.7221 14.4221 7.51648 15.4661 7.51648C16.51 7.51648 17.5437 7.7221 18.5083 8.12161C19.4727 8.5211 20.3492 9.10667 21.0872 9.84486C21.8255 10.583 22.4111 11.4594 22.8106 12.4238C23.2101 13.3884 23.4156 14.4221 23.4156 15.4661C23.4156 16.51 23.2101 17.5437 22.8106 18.5083C22.4111 19.4727 21.8255 20.3491 21.0872 21.0873C19.5964 22.5782 17.5744 23.4157 15.4661 23.4157C13.3577 23.4157 11.3357 22.5782 9.84486 21.0873C8.35402 19.5965 7.51648 17.5745 7.51648 15.4661C7.51648 13.3577 8.35402 11.3357 9.84486 9.84486ZM25.1788 8.70038C25.3617 8.52781 25.5082 8.3203 25.6095 8.09012C25.7108 7.85996 25.7648 7.6118 25.7685 7.36035C25.7722 7.10889 25.7253 6.85927 25.6308 6.62625C25.5362 6.39321 25.3959 6.18152 25.2181 6.0037C25.0402 5.82588 24.8285 5.68555 24.5956 5.59101C24.3626 5.49648 24.1129 5.44964 23.8614 5.45331C23.61 5.45698 23.3618 5.51106 23.1317 5.61235C22.9015 5.71364 22.694 5.86009 22.5215 6.04302C22.1858 6.39878 22.0021 6.87133 22.0092 7.36035C22.0164 7.84937 22.2138 8.31636 22.5596 8.66219C22.9055 9.00802 23.3724 9.20545 23.8614 9.21257C24.3505 9.21971 24.823 9.03597 25.1788 8.70038Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Layout>

      {!isSubmitted && (
        <div className="mobile-sticky-contact-bar">
          <a href="tel:+442038650611" className="mobile-sticky-contact-btn">
            <span>Call Us</span>
          </a>

          <a
            href="mailto:info@cityrelay.com?subject=Property%20Enquiry&body=Hi,%20I%20would%20like%20more%20information."
            className="mobile-sticky-contact-btn"
          >
            <span>Email Us</span>
          </a>
        </div>
      )}
    </>
  );
}

export const pageQuery = graphql`
  query contactPageQuery($id: String!) {
    wpPage(id: { eq: $id }) {
      title
      id
      ...SEO

      contact {
        contact {
          twoColumns {
            textCard {
              illustration {
                ...Image
              }
              subheading
              subheadingColor
              alignText
              heading {
                text
                type
              }
              content
              buttons {
                button {
                  button {
                    button {
                      ...Button
                    }
                  }
                  type
                }
              }
            }
            secondImage {
              ...Image
            }
            thirdImage {
              ...Image
            }
            image {
              ...Image
            }
            backgroundColour {
              colour
            }
            alignImage
            alignSecondImage
          }

          hero {
            textCard {
              illustration {
                ...Image
              }
              subheading
              subheadingColor
              alignText
              heading {
                text
                type
              }
              content
              buttons {
                button {
                  button {
                    button {
                      ...Button
                    }
                  }
                  type
                }
              }
            }
          }

          ctas {
            socialsCta {
              textCard {
                illustration {
                  ...Image
                }
                subheading
                subheadingColor
                alignText
                heading {
                  text
                  type
                }
                content
                buttons {
                  button {
                    button {
                      button {
                        ...Button
                      }
                    }
                    type
                  }
                }
              }
            }

            resourcesCta {
              textCard {
                illustration {
                  ...Image
                }
                subheading
                subheadingColor
                alignText
                heading {
                  text
                  type
                }
                content
                buttons {
                  button {
                    button {
                      button {
                        ...Button
                      }
                    }
                    type
                  }
                }
              }
            }
          }
        }
      }

      resourcesListing {
        resourcesListing {
          categories {
            type
            category {
              name
              slug
              uri
            }
            header {
              heading
              button {
                title
                url
                target
              }
            }
          }
        }
      }
    }
  }
`;